import { Box } from "@mui/material"
import {  isNil, max, min } from "lodash"
import { useState } from "react"
import Item from "../../core/items/Item"
import { DungeonsKeys } from "./DungeonsKeysData"
import { DungeonDto } from "../dungeon/DungeonDto"
import { OotItemDto } from "../hints/OotItemAutocomplete"


interface SmallKeyItemProps {
    id: string
    data: DungeonsKeys,
    keyring?: boolean,
    hideKeys?: boolean
    onClick?: (v: OotItemDto) => void
}

const SmallKeyItem = (props: SmallKeyItemProps) => {

    let [keyObtain, setKeyObtain] = useState<number>(0)
    let [isMq, setIsMq] = useState<boolean>(false);

    let keyring = props.keyring ?? false;

    let maxKey = isMq ? props.data.nbKeysMq : props.data.nbKeysVanilla;

    if(props.data.nbKeysVanilla === 0 && !isMq)
        return null;

    if(props.data.nbKeysMq === 0 && isMq)
        return null;

    return <Box onClick={(e) => {
        if (e.ctrlKey) {
            setIsMq(!isMq)
            let maxKey = (!isMq ? props.data.nbKeysMq : props.data.nbKeysVanilla)
            if (keyObtain > maxKey)
                setKeyObtain(maxKey)
        }
        else if (keyring)
            setKeyObtain(maxKey);
        else
            setKeyObtain(min([keyObtain + 1, isMq ? props.data.nbKeysMq : props.data.nbKeysVanilla]) ?? 0);
    }}
        onContextMenu={(e) => {
            e.preventDefault();
            if (keyring)
                setKeyObtain(0)
            else
                setKeyObtain(max([keyObtain - 1, 0]) ?? 0)
        }}
        display={"flex"}

    >

        <Item
            image={props.data.smallKeyImg}
            id={props.id}
            title={props.data.dungeon + " small key"}
            isObtained={true}
            onClick={() => { if(!isNil(props.onClick)) props.onClick({img: props.data.smallKeyImg, name: props.data.dungeon + " small key"} as OotItemDto) }}
            onRightClick={() => {}}

        />
        {isMq && <Box sx={{ position: "absolute", marginLeft: "30px", fontWeight: "bold", color: "lightblue", zIndex: "999", outlineColor: "black", outline: "1px" }}>MQ</Box>}
        {!props.hideKeys && <Box sx={{ color: keyObtain === maxKey ? "red" : "none", fontWeight: "bold" }}>{keyObtain} / {isMq ? props.data.nbKeysMq : props.data.nbKeysVanilla}</Box>}
    </Box>
}


export default SmallKeyItem

interface SmallKeyItemReworkProps {
    id: string
    dungeon: DungeonDto,
    setDungeonValue: (v: DungeonDto) => void
    keyring?: boolean,
    hideKeys?: boolean
}


export const SmallKeyItemRework = (props: SmallKeyItemReworkProps) => {


    let keyring = props.keyring ?? false;

    let maxKey = props.dungeon.isMq ? props.dungeon.keyMaxMq : props.dungeon.keyMax;

    if(props.dungeon.keyMax === 0 && !props.dungeon.isMq)
        return null;

    if(props.dungeon.keyMaxMq  === 0 && props.dungeon.isMq)
        return null;

    return <Box onClick={(e) => {
        if (e.ctrlKey) {
            let maxKey = (!props.dungeon.isMq ? props.dungeon.keyMaxMq  : props.dungeon.keyMax)
            if (props.dungeon.keyObtained > maxKey)
            {
                props.setDungeonValue({...props.dungeon, isMq: true, keyObtained: maxKey})
            }
            else
                props.setDungeonValue({...props.dungeon, isMq: true})
        }
        else if (keyring)
            props.setDungeonValue({...props.dungeon, keyObtained: maxKey})
        else
            props.setDungeonValue({...props.dungeon, keyObtained: min([props.dungeon.keyObtained + 1, props.dungeon.isMq ? props.dungeon.keyMaxMq : props.dungeon.keyMax]) ?? 0})
    }}
        onContextMenu={(e) => {
            e.preventDefault();
            if (keyring)
                props.setDungeonValue({...props.dungeon, keyObtained: 0})
            else
                props.setDungeonValue({...props.dungeon, keyObtained: max([props.dungeon.keyObtained - 1, 0]) ?? 0})
        }}
        display={"flex"}

    >

        <Item
            image={props.dungeon.imgSmallKey}
            id={props.id}
            title={props.dungeon.name + " small key"}
            isObtained={true}
            onClick={() => { }}
            onRightClick={() => { }}

        />
        {props.dungeon.isMq && <Box sx={{ position: "absolute", marginLeft: "30px", fontWeight: "bold", color: "lightblue", zIndex: "999", outlineColor: "black", outline: "1px" }}>MQ</Box>}
        {!props.hideKeys && <Box sx={{ color: props.dungeon.keyObtained === maxKey ? "red" : "none", fontWeight: "bold" }}>{props.dungeon.keyObtained} / {maxKey}</Box>}
    </Box>
}
